import { fields, createSchema, validate as _validate } from '..';

const { description } = fields;

const schema = createSchema({
  note: description,
});

const validate = (data) => _validate(schema, data);

export default validate;
